import Router from '../router';
import Store from '../store/index';
import Auth from '../helpers/_modules/auth';

// eslint-disable-next-line no-unused-vars
Router.beforeEach((to, from) => {
	const authRequired = to.matched.some(route => route.meta.auth);
	const logged = localStorage.getItem('jwtToken');

	if (authRequired && !logged) {
		return { name: '_login' };
	} if (authRequired && logged) {
		if (Auth.methods.auth().check(authRequired, Store.getters.role)) {
			return true;
		}
		return { name: '_500' };
	} if (to.name === '_login' && logged) {
		return { name: 'home' };
	}

	return true;
});

export default Router;
